<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="4" class="px-4">
        <v-row class="px-2 my-2 mx-4" v-if="lastPage.name">
          <v-btn color="primary" depressed @click="goBack()">
            <v-icon> mdi-chevron-left </v-icon>
          </v-btn>
          <div class="text-h5 text-sm-h4 pl-4">
            {{ $t("showSubstance.goBack.back") }}
          </div>
        </v-row>
        <rules-panel
          v-model="activeRuleId"
          :items="rulesbythemes"
          style="position: sticky; top: 120px"
        ></rules-panel>
      </v-col>
      <v-col cols="12" md="8" class="px-4" v-if="activeRule._id">
        <rules-card-info :rulesItem="activeRule"></rules-card-info>
        <br />
        <table-values-many
          :headers="values.headers"
          :substances="values.substances"
          :massiveHeaders="massiveHeaders"
          :latestChanges="latestRuleChanges"
          :rulesItem="activeRule"
        ></table-values-many>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RulesPanel from "../components/RulesPanel.vue";
import RulesCardInfo from "../components/RulesCardInfo.vue";
import TableValuesMany from "../components/TableValuesMany.vue";
import { monitore } from "../components/helpers/helpers";
import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      activeRule: {},
      activeRuleId: {},
      values: {},
      rulesbythemes: [],
      massiveHeaders: [],
      latestChanges: {},
      latestRuleChanges: {},
    };
  },
  components: {
    RulesPanel,
    RulesCardInfo,
    TableValuesMany,
  },
  watch: {
    activeRuleId() {
      this.getRule(this.activeRuleId.id);
    },
  },
  beforeMount() {
    this.fetchRulesByThemes();
    this.fetchLatestChanges();
  },
  computed: {
    ...mapGetters(["currentPage", "lastPage"]),
  },
  methods: {
    ...mapMutations(["setCurrentPage"]),
    async fetchRulesByThemes() {
      var request = {
        method: "GET",
        url: "/rulesbytheme",
      };
      try {
        var response = await this.axios(request);
        this.rulesbythemes = response.data;
        if (this.currentPage.name === this.$route.name) {
          if (this.currentPage.params) {
            this.getRule(this.currentPage.params.rule.id);
          }
        } else if (this.$route.params.rule) {
          this.getRule(this.$route.params.rule.id);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async fetchLatestChanges() {
      let request = {
        method: "GET",
        url: "/latestchanges",
      };
      try {
        let response = await this.axios(request);
        // console.log(response);
        let changesObj = {};
        response.data.forEach((change) => {
          for (const [ruleID, substancesIDsObj] of Object.entries(
            change.data
          )) {
            if (!changesObj[ruleID]) {
              changesObj[ruleID] = substancesIDsObj;
            } else {
              for (const [subID, values] of Object.entries(substancesIDsObj)) {
                if (!changesObj[ruleID][subID]) {
                  changesObj[ruleID][subID] = values;
                }
              }
            }
          }
        });
        this.latestChanges = changesObj;
        // console.log(this.latestChanges);
      } catch (err) {
        console.log(err);
      }
    },
    async getRule(id) {
      let url = "/rules/" + id;
      var request = { method: "GET", url: url };
      try {
        var response = await this.axios(request);
        monitore("Show rule", id);
        this.activeRule = response.data[0];
        console.log("getRule :", this.activeRule);
        let headers = [];
        this.massiveHeaders = [];
        this.values["substances"] = [];
        this.activeRule.substances.forEach((substance) => {
          // console.log(substance);
          let sub = {};
          sub["substance"] = substance.substance;
          for (const [key, value] of Object.entries(substance.rules)) {
            console.log(`${key}: ${value}`);
            if (headers.indexOf(key) < 0) {
              headers.push(key);
            }
            sub[key] = value;
            if (value !== null && value.length > 200) {
              if (this.massiveHeaders.indexOf(key) < 0) {
                this.massiveHeaders.push(key);
              }
            }
          }
          // console.log(sub);
          this.values["substances"].push(sub);
        });
        this.values["headers"] = [
          {
            text: "Substance",
            value: "substance",
            align: "start",
            sortable: false,
          },
        ];
        headers.forEach((header) => {
          let label = header;
          if (header == 'name') {
            label = 'Nom dans le texte'
          }
          this.values["headers"].push({
            text: label,
            value: header,
            align: "start",
            sortable: false,
          });
        });
        if (this.latestChanges[id]) {
          this.latestRuleChanges = this.latestChanges[id];
        } else {
          this.latestRuleChanges = {};
        }
        this.setCurrentPage({
          name: this.$route.name,
          params: {
            rule: {
              id: id,
              origin: this.activeRule.from,
              name: this.activeRule.usual_name,
            },
            theme: this.activeRule.theme,
          },
        });
        this.scrollToTop();
      } catch (err) {
        console.log(err);
      }
    },
    goBack() {
      this.$router.push(this.lastPage);
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
